<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: auto;
    "
    :style="{width:$store.getters.isPC?'80%':'90%'}"
  >
    <div
      style="
        font-size: 2rem;
        line-height: 2rem;
        font-weight: bold;
        color: #b62d2e;
        text-align: center;
        margin-bottom: 3rem;
      "
    >
      編輯學生資料 Edit Student Info.
    </div>
    <el-form
      ref="form"
      label-position="top"
      label-width="140px"
      :model="formLabelAlign"
      :rules="rules"
    >
      <el-row type="flex" :gutter="20" style="flex-wrap: wrap">
        <!-- <el-form-item>
          <el-popover ref="popover" trigger="click" v-model="isVisible">
            <div style="width: 220px">
              <el-radio-group  v-model="formLabelAlign.avatar">
                <el-radio
                  :label="item.imgUrl"
                  v-for="(item, index) in avatars"
                  :key="index"
                  ><el-avatar :src="item.imgUrl"></el-avatar
                ></el-radio>
              </el-radio-group>
            </div>
            <el-avatar shape="circle"  @click="isVisible = !isVisible" class="form-avatar" slot="reference" :src="formLabelAlign.avatar || `${require(`@/assets/images/account-img.png`)}`" />
          </el-popover>
        </el-form-item> -->
        <el-col>
          <el-form-item>
            <div class="input-title">學生帳戶名稱 Username</div>
            <el-input disabled v-model="formLabelAlign.userNo"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-form-item :label="$t('account.displayName')">
          <el-input v-model="formLabelAlign.name"></el-input>
        </el-form-item> -->
        <!-- <el-form-item :label="$t('account.school')">
          <el-input v-model="formLabelAlign.school"></el-input>
        </el-form-item> -->
        <el-col :xs="24" :sm="12">
          <el-form-item>
            <div class="input-title">性別 Gender</div>
            <el-select
              v-model="formLabelAlign.gender"
              :placeholder="$t('other.pleaseSelect')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in genders"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="input-title">生日 Date of Birth</div>
          <el-form-item>
            <el-date-picker
              align="center"
              v-model="formLabelAlign.birthday"
              type="date"
              placeholder="DD/MM/YY"
              format="dd/MM/yyyy"
              :clearable="false"
              style="width: 100%"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- <el-form-item :label="$t('account.grade')">
          <el-select
            v-model="formLabelAlign.gradeId"
            :placeholder="$t('other.pleaseSelect')"
          >
            <el-option
              v-for="(item, index) in grades"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-col>
          <div class="input-title">重設密碼 Reset Password</div>
          <el-form-item prop="password">
            <div class="input-title">輸入新密碼 New password</div>
            <el-input
              :placeholder="$t('account.passwordPlaceholder')"
              v-model="formLabelAlign.password"
              :class="showPassword1 ? '' : 'password-hidden'"
            >
              <i
                v-show="formLabelAlign.password"
                class="el-icon-view el-input__icon"
                slot="suffix"
                @click="showPassword1 = !showPassword1"
              >
              </i>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item prop="confirmPassword">
            <div class="input-title">重複輸入新密碼 Confirm password</div>
            <el-input
              :placeholder="$t('account.passwordPlaceholder')"
              v-model="formLabelAlign.confirmPassword"
              :class="showPassword2 ? '' : 'password-hidden'"
            >
              <i
                v-show="formLabelAlign.confirmPassword"
                class="el-icon-view el-input__icon"
                slot="suffix"
                @click="showPassword2 = !showPassword2"
              >
              </i>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button
      round
      @click="onConfirm"
      class="security-button"
      style="width: 50%"
      >確認 Confirm</el-button
    >
    <!-- <el-button
        round
        @click="onCancel"
        style="
          display: block;
          margin: 0 auto;
          width: 13.8125rem;
          text-align: center;
          margin-top: 1.5625rem;
        "
        >{{ $t("other.cancel") }}</el-button
      > -->
  </div>
</template>

<script>
import { getGrades } from "@/api/grade";
import { putProfile } from "@/api/user";
import { setUserInfo } from "@/utils/auth";
import { gender } from "@/biz/static-data";
import { formatDate2 } from "@/filters";
export default {
  props: {
    formLabelAlign: {
      type: Object,
      default: function () {},
    },
    detail: {
      type: Object,
      default: function () {},
    },
    studentIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    var validatePassword2 = (rule, value, callback) => {
      if (
        value !== this.formLabelAlign.password &&
        this.formLabelAlign.password
      ) {
        callback(
          new Error("兩次輸入密碼不一致！The passwords are not the same!")
        );
      } else {
        callback();
      }
    };
    var validatePassword = (rule, value, callback) => {
      if (/^(?=.*?[a-zA-Z])(?=.*?\d).{6,16}$/.test(value) || !value) {
        callback();
      } else {
        callback(
          new Error(
            "您的密碼必須介於 6-16 個字元之間，並且至少包含 1 個英文字母及 1 個數字。\nYour password must be between 6-16 characters long, and must contain at least 1 letter and 1 number."
          )
        );
      }
    };
    return {
      isVisible: false,
      grades: [],
      rules: {
        password: [{ validator: validatePassword, trigger: "blur" }],
        confirmPassword: [{ validator: validatePassword2, trigger: "blur" }],
      },
      showPassword1: false, //是否显示密码
        showPassword2: false, //是否显示密码
        pickerOptions: {
        disabledDate(date) {
            return date.getTime() > Date.now() - 8.64e7; //只能选择今天之前的日期，如果没有后面的-8.64e7可以选择今天
        }
    },
    };
  },
  watch: {
    "$store.getters.language": {
      handler(v) {
        this.$nextTick(() => {
          this.genders = gender[v];
        });

        this.getGrades();

        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getGrades();
  },
  methods: {
    onCancel() {
      this.$emit("childByValue", false);
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
      this.detail.students[this.studentIndex] = this.preProcess(
        this.formLabelAlign,
        this.detail.students[this.studentIndex]
      );
      this.putProfile();
        }
      })
    },
    getGrades() {
      getGrades().then((v) => {
        this.grades = v.data;
        this.$forceUpdate();
      });
    },
    preProcess(newData, oldData) {
      let obj = newData;
      Object.keys(obj).forEach((item) => {
        if (
          typeof obj[item] === "undefined" ||
          obj[item] === null ||
          obj[item] === ""
        ) {
          if (item == "password") obj[item] = oldData[item];
        }
      });
      if (obj.birthday) obj.birthday = formatDate2(obj.birthday);
      return obj;
    },
    putProfile() {
      putProfile(this.detail)
        .then(() => {
          this.$message({
            message: "update success",
            type: "success",
          });
          delete this.detail.students[this.studentIndex].confirmPassword;
          setUserInfo("userProfile", this.detail);
        })
        .finally(() => {
          this.$emit("childByValue", false);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.programme-title {
  text-align: left;
  margin-bottom: 1.25rem;
}
.input-title {
  color: #8e8e8e;
  font-weight: bold;
  line-height: 1.6rem;
}
.dialog-personal-title {
  font-size: 1.5rem;
  margin-bottom: 0.625rem;
  font-weight: 600;
}
.form-avatar {
  width: 10rem;
  height: 10rem;
}
.security-button {
  margin: 1.25rem 0;
  border: 0.0625rem solid #fcc03a;
  font-weight: bold;
  font-size: 1.125rem;
  color: #444444;
  background-color: #fcc03a;
}
::v-deep {
  .el-select .el-input .el-select__caret {
    color: #444444;
  }
  .el-input__prefix,
  .el-input__suffix {
    color: #444444;
  }
  .el-input__inner {
    //border-top-right-radius: 3.125rem;
    //border-bottom-right-radius: 3.125rem;
    border-radius: 0.625rem;
    //background-color: #fffbed;
    border: 0.0625rem solid #a1a1a1;
    padding-left: 0.5rem;
    height: 2.75rem;
    line-height: 2.75rem;
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #eeeeee;
    border: 0.0625rem solid #a1a1a1;
  }
  .el-form-item.is-error {
    .el-input__inner {
      border-color: #f1aa55;
    }
    .el-form-item__error {
      color: #8e8e8e;
    }
  }
  .el-form-item__error {
    font-size: 14px;
    position: relative;
  }
  .el-date-editor .el-input__prefix {
    left: auto;
    right: 5px;
  }
}
</style>
